import { render } from "./CustomerProfil.vue?vue&type=template&id=71a398da"
import script from "./CustomerProfil.vue?vue&type=script&lang=js"
export * from "./CustomerProfil.vue?vue&type=script&lang=js"

import "./CustomerProfil.vue?vue&type=style&index=0&id=71a398da&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__